import {Component, OnInit, Inject, ChangeDetectorRef, HostListener, ElementRef} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { NextComponentService } from '../../../../../lib/services/next-component.service';
import { IComponentDetails } from '../../../../../../src/lib/interfaces/component-details.interface';
import { StepComponent } from '../stepcomponent.class';
import { ComponentName } from '../../../../../lib/enum/component-name.enum';
import { ComponentGroup } from '../../../../../lib/enum/component-group.enum';
import { PreviousResidenceInfoComponent } from '../previous-residence-info/previous-residence-info.component';
import { CreditAppService } from '../../../../../lib/services/credit-app.service';
import { IZipCodeRequest } from '../../../../../../src/lib/interfaces/IZipCode.interface';
import { EmploymentInfoComponent } from '../employment-info/employment-info.component';
import { DisableComponentService } from '../../../../../lib/services/disable-component.service';
import { PreviousComponentService } from '../../../../../lib/services/previous-component.service';
import { IConfig, IDescriptionValuePair } from '../../../../../lib/interfaces/config.interface';
import { ResidenceInfo, LookupMappingInformation } from '../../../../../lib/interfaces/credit-application-config.interface';
import { CreditApplicationConfig } from '../../../../../lib/interfaces/credit-application-config.interface';
import { StepType } from '../../../../enum/step-type.enum';
import { getLookupMappings, validateBothNotZero, validateAllFormFields, getBackButton } from '../../../../utils/utils.functions';
import { NotificationsService } from '../../../../../lib/services/notifications.service';
import { NotificationType, INotification } from '../../../../../lib/interfaces/notification.interface';
import { CurrentAddress, ResidenceInformation } from '../../../../interfaces/credit-application.interface';
import { AnalyticsEventService } from '../../../../../lib/services/analytics-event.service';
import { NextCTAClick, ServerError } from '../../../../../lib/actions/analytics.action';
import { IAnalyticsErrorResponse } from '../../../../../lib/interfaces/analytics.interface';
import { ErrorType, UDOConstant } from '../../../../../lib/enum/analytics.enum';
import createNumberMask from '../../../../../lib/utils/numberMask.functions';
import { BingMapsService } from '../../../../services/bing-maps.service';
import { HeapIoService } from '../../../../services/heap-io.service';
@Component({
  selector: 'dt-residence-info',
  templateUrl: './residence-info.component.html',
  styleUrls: ['./residence-info.component.scss'],
  standalone: false
})
export class ResidenceInfoComponent implements OnInit {
  type: StepType = StepType.Buyer;
  residenceInfoForm: UntypedFormGroup;
  numberMask: any;
  zipCodeMask: Array<string | RegExp>;
  isPreviousResidenceInfoRequired = false;
  residenceInfoConfigData: ResidenceInfo;
  creditAppConfigData: CreditApplicationConfig;
  lookupMappingInfo: LookupMappingInformation[];
  residenceTypes: IDescriptionValuePair[];
  states: IDescriptionValuePair[];
  totalYearsAtAddress: IDescriptionValuePair[];
  totalMonthsAtAddress: IDescriptionValuePair[];
  namePattern: string;
  wordOnlyRegexp: string;
  formSubmitted = false;
  isSaving = false;
  Microsoft: any;
  mapReady = false;
  isBuyNow: boolean;
  SubPage = '';
  isLegacyCreditApp:boolean = false;

  public get residenceInfo(): ResidenceInformation {
      if (this.isLegacyCreditApp){
        if(this.creditAppService &&
        this.creditAppService.LegacyCreditApplication[this.type] &&
        this.creditAppService.LegacyCreditApplication[this.type].financialInformation &&
        this.creditAppService.LegacyCreditApplication[this.type].financialInformation.residenceInformation) {
      const currentResidence = {...this.creditAppService.LegacyCreditApplication[this.type].financialInformation.residenceInformation};

      currentResidence.residence = currentResidence.residence !== null ? currentResidence.residence.toString() : null;

      if (Number(currentResidence.residence) === 0) {
        currentResidence.monthlyMortgageAmount = '';
      }
      return currentResidence;
    }
    else {
      return {
        residence: null,
        monthlyMortgageAmount: null,
       
      };
  }
      }
    else {
      if (this.creditAppService &&
        this.creditAppService.CreditApplication[this.type] &&
        this.creditAppService.CreditApplication[this.type].financialInformation &&
        this.creditAppService.CreditApplication[this.type].financialInformation.residenceInformation) {
      const currentResidence = {...this.creditAppService.CreditApplication[this.type].financialInformation.residenceInformation};

      currentResidence.residenceType = currentResidence.residenceType !== null ? currentResidence.residenceType.toString() : null;

      if (Number(currentResidence.residenceType) === 0) {
        currentResidence.monthlyMortgageAmount = '';
      }
      return currentResidence;
    } else {
        return {
          residenceType: null,
          monthlyMortgageAmount: null,
          mortgageCompany: null,
          yearsAtAddress: null,
          monthsAtAddress: null
        };
    }
    }
  }

  public get currentAddress(): CurrentAddress {
    if(this.isLegacyCreditApp){
      /* istanbul ignore next */
      return (this.creditAppService &&
        this.creditAppService.LegacyCreditApplication[this.type] &&
        this.creditAppService.LegacyCreditApplication[this.type].personalInformation &&
        this.creditAppService.LegacyCreditApplication[this.type].personalInformation.currentAddress) || '';
    }else{
    return (this.creditAppService &&
      this.creditAppService.CreditApplication[this.type] &&
      this.creditAppService.CreditApplication[this.type].personalInformation &&
      this.creditAppService.CreditApplication[this.type].personalInformation.currentAddress) || '';
    }
  }

  // public get sameAddressAsApplicant(): boolean {
  //   return (this.creditAppService &&
  //     this.creditAppService.CreditApplication &&
  //     this.creditAppService.CreditApplication.sameAddresAsApplicant) || false;
  // }

  public get sameAddressAsApplicant(): boolean {
    let flag = false;
    if(this.isLegacyCreditApp){
      if (this.creditAppService.LegacyCreditApplication.coBuyer && this.creditAppService.LegacyCreditApplication.buyer) {
        const buyer = this.creditAppService.LegacyCreditApplication.buyer.personalInformation.currentAddress;
        const cobuyer = this.creditAppService.LegacyCreditApplication.coBuyer.personalInformation.currentAddress;
        flag = buyer.addressLine1 === cobuyer.addressLine1
        && buyer.city === cobuyer.city
        && buyer.stateCode === cobuyer.stateCode
        && buyer.postalCode === cobuyer.postalCode;
      }
    } else{
      if (this.creditAppService.CreditApplication.coBuyer && this.creditAppService.CreditApplication.buyer) {
        const buyer = this.creditAppService.CreditApplication.buyer.personalInformation.currentAddress;
        const cobuyer = this.creditAppService.CreditApplication.coBuyer.personalInformation.currentAddress;
        flag = buyer.addressLine1 === cobuyer.addressLine1
        && buyer.city === cobuyer.city
        && buyer.stateCode === cobuyer.stateCode
        && buyer.postalCode === cobuyer.postalCode;
      }
    }
   
    return flag;
  }


  // tslint:disable-next-line: variable-name
  private _formSubmitAttempt = false;
  public get formSubmitAttempt(): boolean {
    return this._formSubmitAttempt;
  }
  public set formSubmitAttempt(value: boolean) {
    this._formSubmitAttempt = value;
  }

  // tslint:disable-next-line: variable-name
  private _rentOrMortgageAmtCleared = true;
  public get rentOrMortgageAmtCleared(): boolean {
    return this._rentOrMortgageAmtCleared;
  }
  public set rentOrMortgageAmtCleared(value: boolean) {
    this._rentOrMortgageAmtCleared = value;
  }

  // tslint:disable-next-line: variable-name
  private _address1Cleared = true;
  public get address1Cleared(): boolean {
    return this._address1Cleared;
  }
  public set address1Cleared(value: boolean) {
    this._address1Cleared = value;
  }

  // tslint:disable-next-line: variable-name
  private _address2Cleared = true;
  public get address2Cleared(): boolean {
    return this._address2Cleared;
  }
  public set address2Cleared(value: boolean) {
    this._address2Cleared = value;
  }

  // tslint:disable-next-line: variable-name
  private _zipCodeCleared = true;
  public get zipCodeCleared(): boolean {
    return this._zipCodeCleared;
  }
  public set zipCodeCleared(value: boolean) {
    this._zipCodeCleared = value;
  }

  // tslint:disable-next-line: variable-name
  private _cityCleared = true;
  public get cityCleared(): boolean {
    return this._cityCleared;
  }
  public set cityCleared(value: boolean) {
    this._cityCleared = value;
  }

  async getBrowserZipcode() {
    let zipcode; 
    try {
        const location = await (window as any).AN?.locationService?.getBrowserLocation();
        if (location?.ValidPostalCode) {
          zipcode = location.PostalCode;
        }
    }
    catch(error) {
      zipcode =  (window as any).AN?.locationService?.getLocation()?.zipCode || '';
    }

    if (zipcode) {
      this.residenceInfoForm.get('Zipcode').setValue(zipcode);
      this.cd.detectChanges();
    }

  }
  
  constructor(private fb: UntypedFormBuilder,
              @Inject('config') public SitecoreConfig: IConfig,
              private nextComponentService: NextComponentService,
              private creditAppService: CreditAppService,
              private disableComponentService: DisableComponentService,
              private previousComponentService: PreviousComponentService,
              private notificationService: NotificationsService,
              private analyticsEventService: AnalyticsEventService,
              private cd: ChangeDetectorRef,
              private readonly heapIoService: HeapIoService) { }

  ngOnInit() {

    this.zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
    this.namePattern = '^[A-Za-z\\s]';
    this.wordOnlyRegexp = '[\\w\\s-,\\.#&\\(\\)\\+\'"]';

    if (
      this.SitecoreConfig &&
      this.SitecoreConfig?.Sitecore &&
      this.SitecoreConfig?.Sitecore?.CreditApplicationConfig && 
      this.SitecoreConfig?.Sitecore?.LookupMappingInformation
    ) {
      this.isBuyNow = this.SitecoreConfig.Sitecore.isBuyNow;
      this.residenceInfoConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig.ResidenceInfo;
      this.creditAppConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig;
      this.lookupMappingInfo = this.SitecoreConfig.Sitecore.LookupMappingInformation;
      this.isLegacyCreditApp = this.SitecoreConfig.Sitecore.isLegacyCreditApp;
     if(this.isLegacyCreditApp){
      this.updateCtas();
     }
   

    this.residenceTypes = getLookupMappings(this.lookupMappingInfo, 'ResidenceType');
    this.states = getLookupMappings(this.lookupMappingInfo, 'StateCodeType');
    this.totalYearsAtAddress = getLookupMappings(this.lookupMappingInfo, 'YearsAtAddressType');
    this.totalMonthsAtAddress = [...getLookupMappings(this.lookupMappingInfo, 'MonthsAtAddressType')].splice(0, 12);
    this.SubPage = this.SitecoreConfig.Sitecore.SubPage ? this.SitecoreConfig.Sitecore.SubPage : '';

 }

    this.residenceInfoForm = this.fb.group({
      ResidenceType: [this.residenceInfo.residenceType || '',
      [Validators.required, Validators.min(1)]
      ],
      RentOrMortgageAmt: [this.residenceInfo.monthlyMortgageAmount,
      [Validators.required]
      ],
      SameAddressAsBuyer: this.sameAddressAsApplicant,
      Address1: [this.currentAddress.addressLine1,
      [Validators.required, Validators.pattern(this.wordOnlyRegexp + '{0,40}')]
      ],
      Address2: ['',
      Validators.pattern(this.wordOnlyRegexp + '{0,40}')],
      Zipcode: [this.currentAddress.postalCode,
      [Validators.required, Validators.minLength(5)]
      ],
      City: [this.currentAddress.city,
      [Validators.required, Validators.pattern(this.namePattern + '{0,30}')]],
      State: [this.currentAddress.stateCode || '', [Validators.required]],
      residenceDurationGroup: this.fb.group({
        YearsAtAddress: [
          this.currentAddress.monthsAtAddress + this.currentAddress.yearsAtAddress === 0 ?
            '' :
            this.currentAddress.yearsAtAddress,
          [Validators.required]],
        MonthsAtAddress: [
          this.currentAddress.monthsAtAddress + this.currentAddress.yearsAtAddress === 0 ?
            '' :
            this.currentAddress.monthsAtAddress, [Validators.required]]
      })
    });

    setTimeout(() => {
      if (this.currentAddress.postalCode) {
        this.residenceInfoForm.get('Zipcode').updateValueAndValidity({
          emitEvent: true,
          onlySelf: true
        });
      }
    });

    if (this.type === StepType.CoBuyer) {
      this.setAddress(this.sameAddressAsApplicant, true);
    }

    if (this.residenceTypes && this.residenceInfo.residenceType &&
      this.residenceInfo.residenceType !== 0 &&
      !this.residenceTypes.some(e => e.Value === this.residenceInfo.residenceType.toString())) {
      this.residenceInfoForm.get('ResidenceType').setValue('');
    }

    this.residenceInfoForm.get('Zipcode').valueChanges.subscribe(async(value) => {
      if (
        value !== undefined &&
        value !== null &&
        value.toString().length === 5
      ) {
        const request: IZipCodeRequest = {
          zipCode: value
        };


        const zipCodeResponse = await this.creditAppService.getZipCodeInfo(request);
        
        if (zipCodeResponse && zipCodeResponse.Success && this.residenceInfoForm) {
          this.residenceInfoForm.patchValue({
            City: zipCodeResponse.ZipCodeData.City,
            State: zipCodeResponse.ZipCodeData.StateCode
          });
        } else if (zipCodeResponse && !zipCodeResponse.Success) {
          if (
            zipCodeResponse.ErrorCodes &&
            zipCodeResponse.ErrorCodes.length > 0
          ) {
            this.residenceInfoForm.patchValue({
              City: '',
              State: ''
            });
            this.residenceInfoForm
              .get('Zipcode')
              .setErrors({ invalidZipCode: true });
          }
        }
      
      }
    });

    this.residenceInfoForm.get('SameAddressAsBuyer').valueChanges.subscribe(value => {
      this.setAddress(value);
    });
    if (this.currentAddress.yearsAtAddress <= 1) {
      this.isPreviousResidenceInfoRequired = true;
    }
    this.residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').valueChanges.subscribe(value => {
      if (value && value <= 1) {
        this.isPreviousResidenceInfoRequired = true;
      } else {
        this.isPreviousResidenceInfoRequired = false;
      }
    });

    this.numberMask = createNumberMask({
      prefix: ''
    });

    if (this.residenceInfoForm.valid) {
      this.formSubmitted = true;
      this.residenceInfoForm.markAsPristine();
    }

    validateAllFormFields(this.residenceInfoForm);

    if (this.type === StepType.CoBuyer) {
      this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
        if (n !== null && n.Type === NotificationType.coBuyerDeactivation) {
          this.residenceInfoForm.markAsDirty();
        }
      });
    }

    if (this.SitecoreConfig && this.SitecoreConfig?.Sitecore && this.SitecoreConfig?.Sitecore?.IsAzureMapsEnabled) {
      const coordinates = this.SitecoreConfig.Sitecore.UserPreferredCoordinates;
      const addrElem = document.getElementById('address1');
      addrElem.classList.add('azure-maps-auto-suggest');
      (window as any)
        .AzureMapsLoaded({ container: 'azure-maps-auto-suggest', latitude: coordinates.Latitude,
        longitude: coordinates.Longitude, address: 'address1', city: 'city', state: 'state', zip: 'zip_code', cfrom: 'prequal' });
    } else {
      if (this.SitecoreConfig && this.SitecoreConfig?.Sitecore && this.SitecoreConfig?.Sitecore?.BingKey) {
        BingMapsService.load()
          .then(res => {
              this.mapReady = true;
          }).then(() => {
            setTimeout(() => {
              /* istanbul ignore else */
              if (this.mapReady && typeof Microsoft !== 'undefined') {
                this.loadMap();
              }
            }, 1);
          });
      }
    }
    if(this.isBuyNow){
      if(this.type === StepType.Buyer){
        this.heapIoService.trackPageview('credit-application/residence-information');  
      }
      else if(this.type === StepType.CoBuyer){
        this.heapIoService.trackPageview('credit-application/cobuyer-residence-information');  
      }
   
    }


  }

  goNext() {
    let ca:any
    this.formSubmitAttempt = true;
    this.address1Cleared = false;
    this.rentOrMortgageAmtCleared = false;
    this.zipCodeCleared = false;
    this.cityCleared = false;
    getBackButton();
    if ((this.residenceInfoForm.valid && this.residenceInfoForm.dirty)
      || (this.residenceInfoForm.valid && !this.formSubmitted)) {

        if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
          ca = { ...this.creditAppService.LegacyCreditApplication };
        }else{
          ca = { ...this.creditAppService.CreditApplication };
        }


      const stepCount = (this.type === StepType.Buyer ? 2 : 8);
      // if (ca.step <= stepCount || ca.step === 13) {
      ca.step = stepCount;
      // }

      ca[this.type].personalInformation.currentAddress = {
        addressLine1: this.residenceInfoForm.get('Address1').value,
        addressLine2: this.residenceInfoForm.get('Address2').value,
        city: this.residenceInfoForm.get('City').value,
        monthsAtAddress: this.residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').value,
        postalCode: this.residenceInfoForm.get('Zipcode').value,
        stateCode: this.residenceInfoForm.get('State').value,
        yearsAtAddress: this.residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').value
      };
      ca[this.type].financialInformation.residenceInformation.residenceType = this.residenceInfoForm.get('ResidenceType').value;
      ca[this.type].financialInformation.residenceInformation.monthlyMortgageAmount =
        this.residenceInfoForm.get('RentOrMortgageAmt').value.toString().replace(/,\s?/g, '').replace(/\b(0(?!\b))+/g, '');

      if (this.type === StepType.CoBuyer) {
        ca.sameAddresAsApplicant = this.residenceInfoForm.get('SameAddressAsBuyer').value;
      }
      if (!this.isPreviousResidenceInfoRequired) {
        if (Array.isArray(ca[this.type].personalInformation.previousAddress)
          && ca[this.type].personalInformation.previousAddress.length > 0) {
          ca[this.type].personalInformation.previousAddress = [];
        }
        if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
          ca[this.type].personalInformation.previousAddress = null;
        }
      }
      this.isSaving = true;
      if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
        ca[this.type].personalInformation.currentAddress.state = '';
        ca[this.type].personalInformation.currentAddress.monthsAtAddress = parseInt(this.residenceInfoForm.get('residenceDurationGroup.MonthsAtAddress').value);
        ca[this.type].personalInformation.currentAddress.yearsAtAddress = parseInt(this.residenceInfoForm.get('residenceDurationGroup.YearsAtAddress').value);
        ca[this.type].financialInformation.residenceInformation.residence = this.residenceInfoForm.get('ResidenceType').value ? parseInt(this.residenceInfoForm.get('ResidenceType').value) : 0;
        ca[this.type].financialInformation.residenceInformation.monthlyMortgageAmount =  ca[this.type].financialInformation.residenceInformation.monthlyMortgageAmount ? parseInt( ca[this.type].financialInformation.residenceInformation.monthlyMortgageAmount):0;
      }
      this.creditAppService.SaveCreditApp(ca,this.SubPage).subscribe(response => {
        if (response.isSuccess) {
          this.isSaving = false;
          this.formSubmitted = true;
          this.residenceInfoForm.markAsPristine();
          this.loadNextComponent();
        } else {
          this.isSaving = false;
          this.reportErrorResponse(response);
        }
      }, error => {
        this.isSaving = false;
        this.reportErrorResponse(error);
      });
    } else {
      if (this.residenceInfoForm.valid) {
        this.loadNextComponent();
      }
    }
  }

  reportErrorResponse(errorData: any) {
    const analyticsErrorResponse: IAnalyticsErrorResponse = {
      error: errorData.statusCode ? errorData.statusCode : UDOConstant.ErrorCode,
      error_message: errorData.message ? errorData.message : UDOConstant.ServiceUnavailable,
      error_type: ErrorType.CreditAppNotSaved
    };
    this.analyticsEventService.reportAnalyticsEvent(
      new ServerError(new StepComponent(ResidenceInfoComponent,
        ComponentName.ResidenceInfoComponent,
        ComponentGroup.ResidenceInfo, true, this.type),
        analyticsErrorResponse));
  }

  setAddress(checked: boolean, onInitialization = false) {
    if (checked !== null && checked !== undefined && checked) {
      if(this.isLegacyCreditApp){
        this.residenceInfoForm.patchValue({
          Address1: this.creditAppService.LegacyCreditApplication[StepType.Buyer].personalInformation.currentAddress.addressLine1,
          Address2: '',
          Zipcode: this.creditAppService.LegacyCreditApplication[StepType.Buyer].personalInformation.currentAddress.postalCode,
          City: this.creditAppService.LegacyCreditApplication[StepType.Buyer].personalInformation.currentAddress.city,
          State: this.creditAppService.LegacyCreditApplication[StepType.Buyer].personalInformation.currentAddress.stateCode
        }, { emitEvent: false }
        );
      }else{
        this.residenceInfoForm.patchValue({
          Address1: this.creditAppService.CreditApplication[StepType.Buyer].personalInformation.currentAddress.addressLine1,
          Address2: '',
          Zipcode: this.creditAppService.CreditApplication[StepType.Buyer].personalInformation.currentAddress.postalCode,
          City: this.creditAppService.CreditApplication[StepType.Buyer].personalInformation.currentAddress.city,
          State: this.creditAppService.CreditApplication[StepType.Buyer].personalInformation.currentAddress.stateCode
        }, { emitEvent: false }
        );
      }
    
    } else {
      this.residenceInfoForm.patchValue({
        Address1: onInitialization ? this.currentAddress.addressLine1 : '',
        Address2: '',
        Zipcode: onInitialization ? this.currentAddress.postalCode : '',
        City: onInitialization ? this.currentAddress.city : '',
        State: onInitialization ? this.currentAddress.stateCode :'',
      }, { emitEvent: false }
      );

      this.clearValidations(this.residenceInfoForm.get('Address1'));
      this.clearValidations(this.residenceInfoForm.get('Address2'));
      this.clearValidations(this.residenceInfoForm.get('Zipcode'));
      this.clearValidations(this.residenceInfoForm.get('City'));
      this.clearValidations(this.residenceInfoForm.get('State'));
    }
  }

  private loadNextComponent() {
    let nextComponent: IComponentDetails;
    let componentToBeDisabled: IComponentDetails;
    if (this.isPreviousResidenceInfoRequired) {
      componentToBeDisabled = null;
      if (this.type === StepType.Buyer) {
        nextComponent = {
          groupName: ComponentGroup.ResidenceInfo,
          component: new StepComponent(PreviousResidenceInfoComponent,
            ComponentName.PreviousResidenceInfoComponent,
            ComponentGroup.ResidenceInfo, true),
          componentName: ComponentName.PreviousResidenceInfoComponent
        };

        this.analyticsEventService.reportAnalyticsEvent(
          new NextCTAClick(new StepComponent(ResidenceInfoComponent,
            ComponentName.ResidenceInfoComponent,
            ComponentGroup.ResidenceInfo, true, this.type))
        );
      } else {
        nextComponent = {
          groupName: ComponentGroup.CoBuyerResidence,
          component: new StepComponent(PreviousResidenceInfoComponent,
            ComponentName.CoBuyerPreviousResidenceInfoComponent,
            ComponentGroup.CoBuyerResidence, true, StepType.CoBuyer),
          componentName: ComponentName.CoBuyerPreviousResidenceInfoComponent
        };

        this.analyticsEventService.reportAnalyticsEvent(
          new NextCTAClick(new StepComponent(ResidenceInfoComponent,
            ComponentName.CoBuyerResidenceInfoComponent,
            ComponentGroup.CoBuyerResidence, true, this.type))
        );
      }
    } else {
      if (this.type === StepType.Buyer) {

        this.notificationService.broadcastNotification({
          Message: 'Previous Residence is not required',
          Type: NotificationType.clearPreviousResidence,
          Payload: StepType.Buyer
        });

        componentToBeDisabled = {
          groupName: ComponentGroup.ResidenceInfo,
          component: new StepComponent(PreviousResidenceInfoComponent,
            ComponentName.PreviousResidenceInfoComponent,
            ComponentGroup.ResidenceInfo, false),
          componentName: ComponentName.PreviousResidenceInfoComponent
        };
        nextComponent = {
          groupName: ComponentGroup.EmploymentInfo,
          component: new StepComponent(EmploymentInfoComponent, ComponentName.EmploymentInfoComponent, ComponentGroup.EmploymentInfo, true),
          componentName: ComponentName.EmploymentInfoComponent
        };

        this.analyticsEventService.reportAnalyticsEvent(
          new NextCTAClick(new StepComponent(ResidenceInfoComponent,
            ComponentName.ResidenceInfoComponent,
            ComponentGroup.ResidenceInfo, true, this.type))
        );
      } else {

        this.notificationService.broadcastNotification({
          Message: 'Previous Residence is not required',
          Type: NotificationType.clearPreviousResidence,
          Payload: StepType.CoBuyer
        });

        componentToBeDisabled = {
          groupName: ComponentGroup.CoBuyerResidence,
          component: new StepComponent(PreviousResidenceInfoComponent,
            ComponentName.CoBuyerPreviousResidenceInfoComponent,
            ComponentGroup.CoBuyerResidence, false, StepType.CoBuyer),
          componentName: ComponentName.CoBuyerPreviousResidenceInfoComponent
        };
        nextComponent = {
          groupName: ComponentGroup.CoBuyerEmployment,
          component: new StepComponent(EmploymentInfoComponent,
            ComponentName.CoBuyerEmploymentInfoComponent,
            ComponentGroup.CoBuyerEmployment, true, StepType.CoBuyer),
          componentName: ComponentName.CoBuyerEmploymentInfoComponent
        };

        this.analyticsEventService.reportAnalyticsEvent(
          new NextCTAClick(new StepComponent(ResidenceInfoComponent,
            ComponentName.CoBuyerResidenceInfoComponent,
            ComponentGroup.CoBuyerResidence, true, this.type))
        );
      }
    }

    this.disableComponentService.disableComponent(componentToBeDisabled);
    this.nextComponentService.loadComponent(nextComponent);
  }

  goBack() {
    let currentComponent: IComponentDetails;
    if (this.type === StepType.Buyer) {
      currentComponent = {
        groupName: ComponentGroup.ResidenceInfo,
        component: new StepComponent(ResidenceInfoComponent, ComponentName.ResidenceInfoComponent,
          ComponentGroup.ResidenceInfo, true),
        componentName: ComponentName.ResidenceInfoComponent
      };
      if (this.isBuyNow) {
        try {
          if ((window as any).buynow) {
            /* istanbul ignore next */
            (window as any).buynow.navigation.showPrev();
            /* istanbul ignore next */
            (window as any).buynow.navigation.showNext();
          }
        } catch (e) {
          /* istanbul ignore next */
          console.error(e);
        }
      }
    } else {
      currentComponent = {
        groupName: ComponentGroup.CoBuyerResidence,
        component: new StepComponent(ResidenceInfoComponent, ComponentName.CoBuyerResidenceInfoComponent,
          ComponentGroup.CoBuyerResidence, true, StepType.CoBuyer),
        componentName: ComponentName.CoBuyerResidenceInfoComponent
      };
    }
    /* istanbul ignore next */
    this.previousComponentService.loadComponent(currentComponent);
  }

  clearValidations(formControl: AbstractControl) {
    if (formControl.invalid) {
      formControl.reset('');
      this.controlCleared(formControl);
      // this.formSubmitAttempt = false;
      // this.isControlCleared = true;
    }
  }

  controlCleared(formControl) {
    switch (this.getControlName(formControl)) {
      case 'RentOrMortgageAmt':
        this.rentOrMortgageAmtCleared = true;
        break;
      case 'Address1':
        this.address1Cleared = true;
        break;
      case 'Address2':
        this.address2Cleared = true;
        break;
      case 'Zipcode':
        this.zipCodeCleared = true;
        break;
      case 'City':
        this.cityCleared = true;
        break;
      // tslint:disable-next-line: no-switch-case-fall-through
      default:
        break;
    }
  }

  getControlName(c: AbstractControl): string | null {
    const formGroup = c.parent && c.parent.controls;
    return formGroup ? Object.keys(formGroup).find(name => c === formGroup[name]) : null;
  }

  loadMap() {
    Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
      callback: this.onLoadBingMaps.bind(this),
      errorCallback: this.onErrorBingMaps.bind(this),
      credentials: this.SitecoreConfig.Sitecore.BingKey
    });
  }

  onLoadBingMaps() {
    let options: any;
    if (this.SitecoreConfig.Sitecore.UserPreferredCoordinates !== undefined) {
      const coordinates = this.SitecoreConfig.Sitecore.UserPreferredCoordinates;
      const location = new Microsoft.Maps.Location(coordinates.Latitude, coordinates.Longitude);
      options = { maxResults: 3, countryCode: 'US', placeSuggestions: false, userLocation: location };
    } else {
      /* istanbul ignore next */
      options = { maxResults: 3, countryCode: 'US', placeSuggestions: false };
    }

    const manager = new Microsoft.Maps.AutosuggestManager(options);
    const input = '#address1';
    const boxContainer = '#searchBoxContainer';
    /* istanbul ignore next */
    if (document.querySelector(input) && document.querySelector(boxContainer)) {
      manager.attachAutosuggest(input, boxContainer, this.selectedSuggestionAddress.bind(this));
    } else {
      console.error('Elements for Bing AutoSugest not found');
    }
  }
/* istanbul ignore next */
  onErrorBingMaps(message) {
    console.log(message);
  }

  selectedSuggestionAddress(suggestionResult) {
    this.residenceInfoForm.get('Address1').setValue(suggestionResult.address && suggestionResult.address.addressLine || '');
    this.residenceInfoForm.get('City').setValue(suggestionResult.address && suggestionResult.address.locality || '');
    this.residenceInfoForm.get('State').setValue(this.getBingState(suggestionResult) || '');
    this.residenceInfoForm.get('Zipcode').setValue(suggestionResult.address && suggestionResult.address.postalCode || '');
    setTimeout(() => {
      this.residenceInfoForm.get('Address1').setValue(suggestionResult.address && suggestionResult.address.addressLine || '');
    }, 1);
  }

  getBingState(suggestionResult: any) {
    let suggestedState: any;
    let state: string;
    if(this.states){
    if (suggestionResult && suggestionResult.address && suggestionResult.address.adminDistrict !== '') {
      suggestedState = this.states.filter(s => s.Details && s.Details.trim() === suggestionResult.address.adminDistrict.trim());
      state = suggestedState.length > 0 ? suggestedState[0].Value : '';
    }
    return state;
  }
  }

  @HostListener('window:AzureMapsZipUpdate', ['$event'])
  onAzureMapsZipUpdate(event) {
    /* istanbul ignore next */
    if (event && event.detail && document.getElementById('address1') !== null) {
      this.residenceInfoForm.get('Address1').setValue(event.detail.address);
      this.residenceInfoForm.get('City').setValue(event.detail.city);
      this.residenceInfoForm.get('State').setValue(event.detail.state);
      this.residenceInfoForm.get('Zipcode').setValue(event.detail.zip);
    }
  }

  updateCtas() {
    try {
      (window as any).standalonePrequal.updateCtasPosition();
    } catch (error) {/* istanbul ignore next */
      console.log(error);
    }
  }

  isMobile() {
    return window.innerWidth < 767 || (window.innerWidth > 768 && window.innerHeight < 480);
  }

  @HostListener('window:resize', ['$event'])
  reSize(e) {
    /* istanbul ignore next */
   this.isMobile();
  }


}
